import OpeningScreen from './OpeningScreen'

export default OpeningScreen
